<template>
<div class="warp-container">
    <div class="pageerror-container">
        <img class="rotating" src="../assets/spaceman.svg" alt="">
        <div class="tips-text">服务器正在维护升级，请稍后访问</div>
        <span class="backhome" @click="goHome">返回首页</span>
    </div>
</div>
</template>
<script>
export default{
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>
<style scoped lang="less">
.warp-container{
  height: 100vh;
  background-color: #ffffff;
}
.pageerror-container{
  height: 100%;
  position: relative;
}
.pageerror-container img{
  display: block;
  width: 10rem;
}
img.rotating {
  position: absolute;
  left: 50%;
  top: 3.4rem;
  margin-left: -5rem;
  -webkit-transition: opacity 2s ease-in;
  -moz-transition: opacity 2s ease-in;
  -o-transition: opacity 2s ease-in;
  -ms-transition: opacity 2s ease-in;
  transition: opacity 2s ease-in;
}

@-webkit-keyframes rotating {
from{
-webkit-transform: rotate(0deg);
}
to{
-webkit-transform: rotate(360deg);
}
}

@-moz-keyframes rotating {
from{
-moz-transform: rotate(0deg);
}
to{
-moz-transform: rotate(360deg);
}
}

@-o-keyframes rotating {
from{
-o-transform: rotate(0deg);
}
to{
-o-transform: rotate(360deg);
}
}

@-ms-keyframes rotating {
from{
-ms-transform: rotate(0deg);
}
to{
-ms-transform: rotate(360deg);
}
}

.rotating {
-webkit-animation: rotating 120s linear infinite;
-moz-animation: rotating 120s linear infinite;
}
.tips-text{
  position: absolute;
  font-size: 0.8rem;
  text-align: center;
  left: 0;
  right: 0;
  top: 50%;
  margin-top: 4rem;
  color: #00B097;
}
.backhome{
  position: absolute;
  font-size: 0.7rem;
  color: #ffffff;
  background-color: #00B097;
  width: 4.6rem;
  height: 1.8rem;
  text-align: center;
  line-height: 1.8rem;
  border-radius: 3px;
  left: 50%;
  margin-left: -2rem;
  bottom: 2rem;
}
</style>
